<template>
	<div class="p-2" id="dreams_log_button">
		<div class="row">
			<div class="col-12 mb-2">
				<b-input-group>
					<b-form-input v-model="search_text" placeholder="Search dreams..."></b-form-input>
					<b-input-group-append>
						<b-button variant="outline-primary" class="m-0" @click="dreamsGet('search')">
							<i class="fas fa-search"></i>
						</b-button>
						<b-button variant="outline-secondary" class="m-0" @click="dreamsGet('latest')">
							<i class="fas fa-times"></i>
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</div>

			<div class="col-12 mb-2 text-left">
				<b-button variant="outline-primary" @click="openModal">
					<i class="fas fa-cloud-meatball fa-1x"></i> Log My Dream
				</b-button>
			</div>
		</div>

		<div v-if="searching == 1" class="text-muted">
			<i class="fas fa-atom fa-spin"></i> searching
		</div>

		<div v-if="dreams !== null && dreams.length > 0" class="text-left">
			<b-list-group v-for="(dream, index) in dreams" :key="'dream-' + index">
				<b-list-group-item
					@click="viewDream(dream)"
					class="d-flex justify-content-between align-items-center mb-1 small pointer"
				>
					<div>
						<i
							v-if="dream.has_new_comment == 1"
							class="fas fa-comment-dots fa-flip-horizontal fa-2x mr-2 text-danger"
						></i>
						<span v-text="dream.title"></span>
					</div>
					<small class="gold" style="min-width: 80px">
						<b v-text="dream.date_human"></b>
					</small>
				</b-list-group-item>
			</b-list-group>
		</div>
		<div v-else>
			<p class="text-muted text-center">No dreams found</p>
		</div>

    <add-dream-log
      :readonly="readonly"
      :active-dream="active_dream"
      :status="modal_status"
      @submitted="onAddDream()"
      v-if="active_dream"
    ></add-dream-log>

	</div>
</template>

<script>
import axios from 'axios';
import AddDreamLog from "@/components/dreams/AddDreamLog";

export default {
	name: 'DreamsLog',
	components: {
		AddDreamLog
	},
	props: {
		userid: {
			type: Number,
			default: null,
		},
		limit: {
			type: Number,
			default: 14,
		},
		readonly: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			active_dream: null,
			dreams: [],
			modal_status: 'add',
			search_text: '',
			searching: 1,
			screenHeight: screen.availHeight,
		};
	},
	computed: {},
	methods: {
		dreamsGet(type) {
			console.log('dreamsGet:');
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('readonly', this.readonly);

			if (this.userid !== null) {
				params.append('user_id', this.userid);
			}

			params.append('category', 'dreams');
			params.append('limit', this.limit);
			params.append('order_by', 'access');
			params.append('order_direction', 'desc');
			params.append('type', 'edit');

			if (type == 'search') {
				params.append('search_text', _this.search_text);
			}

			this.dreams = [];
			this.search_text = '';
			this.searching = 1;

			axios({
				url: _this.$store.state.api_url + 'dreamsGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.dreams && response.data.dreams !== null) {
						let entries = Object.values(response.data.dreams);
						_this.dreams = entries;

						_this.$store.commit('layoutCardClassSet', {
							col_type_class: 'row-cols-1 row-cols-md-1',
						});
					}

					_this.searching = 0;
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		viewDream(dream) {
			if (dream.has_new_comment == 1) {
				this.mark_dream_viewed(dream);
			}

			this.active_dream = dream;
			this.modal_status = 'edit';

			this.$nextTick(() => {
				this.$bvModal.show('dream_wrapper')
			})
		},

		mark_dream_viewed(dream) {
			dream.has_new_comment = 0;
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('forum_id', dream.id);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'forumRepliesViewed',
				data: params,
			})
				.then(function () {})
				.catch(function (error) {
					console.log(error);
				});
		},

		openModal() {
      this.active_dream = {
        date_edit: (new Date).toISOString().split('T')[0],
        can_comment: true
      }
			this.modal_status = 'add';
      this.$nextTick(() => {
        setTimeout(() => this.$bvModal.show('dream_wrapper'), 100)
      })
    },
    onAddDream() {
      this.$bvModal.hide('dream_wrapper');
      this.active_dream = null
      this.dreamsGet('latest');
    }
	},
	mounted() {
		console.log(screen.availHeight);
		this.dreamsGet('latest');
		this.$root.$on('dream-saved', () => this.dreamsGet('lestest'))
	},
	beforeDestroy() {
		this.$root.$off('dream-saved')
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
